import { render, staticRenderFns } from "./favRecord.vue?vue&type=template&id=709e8254&scoped=true"
import script from "./favRecord.vue?vue&type=script&lang=js"
export * from "./favRecord.vue?vue&type=script&lang=js"
import style0 from "./favRecord.vue?vue&type=style&index=0&id=709e8254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e8254",
  null
  
)

export default component.exports